'use client';
import { useEffect, useState } from 'react';
import type { FC } from 'react';

import { Option } from '@/shared/config';
import { Sorting } from '@/shared/ui';

import styles from './sort.module.scss';

interface SortProps {
  value?: string;
  options?: Option[];
  onSelect?: (value: string) => void;
}

export const Sort: FC<SortProps> = (props) => {
  const { options, onSelect, value } = props;
  const [selected, setSelected] = useState(value);

  useEffect(() => {
    if (value) {
      setSelected(value);
      return;
    }

    if (options?.length) {
      setSelected(options[0]?.value.toString());
    }
  }, [value, options]);

  if (!options?.length) {
    return null;
  }

  const handleSelect = (value: string) => {
    setSelected(value);
    onSelect?.(value);
  };

  return (
    <div className={styles.sort}>
      <Sorting options={options} value={selected} onChange={handleSelect} />
    </div>
  );
};
